import React, { useState } from 'react';
import Modal from '../Modal';

const CookieBanner = () => {
  const [targetCookiesSw, setTargetCookiesSw] = useState(false);
  const [funcCookiesSw, setFuncCookiesSw] = useState(false);
  const [perfCookiesSw, setPerfCookiesSw] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [isCookiePolicyVisible, setIsCookiePolicyVisible] = useState(
    !localStorage.getItem('cookiePolicy')
  );

  const [openAccordion, setOpenAccordion] = useState(null);
  const [showZorunluTable, setShowZorunluTable] = useState(false);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  const zorunluCookies = [
    {
      name: '{uniqueField} (proofKey çerezi)',
      description:
        'Kullanıcının benzersiz alan adıyla açılan, içinde proofKey + uniqueField bulunan çerez',
      purpose:
        'Sonraki girişlerde kullanıcıyı backend’e karşı doğrulama / hızlı-tekrar giriş (proofKey kontrolü)',
      duration: 'Kalıcı — expires=31 Dec 9999 (kullanıcı silmedikçe süresiz)',
    },
    {
      name: 'token',
      description: 'Oturum JWT erişim belirteci',
      purpose:
        'Her API isteğinde Authorization: Bearer ile gönderilerek backend’de kimlik doğrulama',
      duration:
        'Oturum boyunca (çıkış/temizleme yapılana kadar; token backend’de expireSecond süresiyle geçerli)',
    },
    {
      name: 'refreshToken',
      description: 'Yenileme belirteci',
      purpose: 'Erişim token’ı süresi dolduğunda backend’den yeni token alma',
      duration: 'Oturum boyunca (çıkışta silinir)',
    },
    {
      name: 'expireSecond',
      description: 'Token geçerlilik süresi (saniye)',
      purpose: 'Token’ın ne zaman yenilenmesi gerektiğini belirleme',
      duration: 'Oturum boyunca',
    },
    {
      name: 'tenantName',
      description: 'Kullanıcının bağlı olduğu kiracı (tenant) adı',
      purpose:
        'Her istekte X-Tenant başlığıyla gönderilerek backend’de doğru kiracıya yönlendirme/doğrulama',
      duration: 'Oturum boyunca',
    },
    {
      name: 'username',
      description: 'Kullanıcı adı',
      purpose: 'Giriş, 2FA (SMS doğrulama) ve şifre işlemlerinde backend’e kimlik iletme',
      duration: 'Oturum boyunca',
    },
  ];

  const handleSavePolicy = () => {
    localStorage.setItem('cookiePolicy', true);
    localStorage.setItem('targetCookies', targetCookiesSw);
    localStorage.setItem('funcCookies', funcCookiesSw);
    localStorage.setItem('perfCookies', perfCookiesSw);
    setIsCookiePolicyVisible(false);
    setShowSettingsModal(false);
  };

  const handleAcceptAll = () => {
    setTargetCookiesSw(true);
    setFuncCookiesSw(true);
    setPerfCookiesSw(true);
    
    localStorage.setItem('cookiePolicy', true);
    localStorage.setItem('targetCookies', true);
    localStorage.setItem('funcCookies', true);
    localStorage.setItem('perfCookies', true);
    setIsCookiePolicyVisible(false);
    setShowSettingsModal(false);
  };

  if (!isCookiePolicyVisible) return null;

  return (
    <>
      {/* Cookie Banner */}
      {!showSettingsModal && (
        <div
          className="cookie-banner"
          style={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            maxWidth: 550,
            backgroundColor: 'rgba(0, 0, 0, 0.92)',
            color: '#fff',
            padding: '20px 24px',
            borderRadius: 12,
            zIndex: 9999,
            fontSize: 13,
            lineHeight: '1.6',
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          }}
        >
          <h3 style={{ fontSize: 16, marginBottom: 10, fontWeight: 700, color: '#ffffff' }}>
            Daha iyi bir deneyim için izninizi istiyoruz.
          </h3>
          <p style={{ margin: '0 0 16px', opacity: 0.85 }}>
            Web sitesinin çalışması için zorunlu bazı çerezler sistemlerimizde
            kullanılmaktadır ve kapatılamaz. Web sitesinde dolaşmanıza ve gizlilik
            tercihlerinizi belirleme, giriş yapma veya formları doldurma gibi
            hizmet talebine karşılık gelen eylemler gibi özelliklerini kullanmanıza
            olanak sağlamaktadır.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button
              type="button"
              className="cookie-btn cookie-btn--settings"
              onClick={() => setShowSettingsModal(true)}
            >
              Çerez Ayarları
            </button>
            <button
              type="button"
              className="cookie-btn cookie-btn--accept"
              onClick={handleAcceptAll}
            >
              Tümünü Kabul Et
            </button>
          </div>
        </div>
      )}

      {/* Cookie Settings Modal */}
      <Modal
        isOpen={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
        showCloseIconButton={true}
        showCloseButton={false}
      >
        <div style={{ padding: '8px 12px', maxWidth: 650, maxHeight: '80vh', overflowY: 'scroll' }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8, color: '#333', textAlign: 'center' }}>
            Çerez Ayarları
          </h2>
          <p style={{ fontSize: 13, color: '#555', marginBottom: 5, lineHeight: 1.5 }}>
            Herhangi bir web sitesini ziyaret ettiğinizde site, tarayıcınızdan genellikle tanımlama bilgileri biçiminde olmak üzere bilgiler alabilir veya depolayabilir. Bu bilgiler; siz, tercihleriniz ya da cihazınız hakkında olabilir veya siteyi beklediğiniz şekilde çalıştırmak üzere kullanılabilir. Bilgiler çoğunlukla sizi doğrudan tanımlamaz ancak size daha kişiselleştirilmiş bir web deneyimi sunabilir. Bazı tanımlama bilgisi türlerine izin vermemeyi seçebilirsiniz. Daha fazla bilgi edinmek ve varsayılan ayarlarımızı değiştirmek için farklı kategori başlıklarına tıklayın. Bununla birlikte, bazı tanımlama bilgisi türlerini engellediğinizde site deneyiminiz ve sunabildiğimiz hizmetler bu durumdan etkilenebilir.
          </p>

          <a 
            href="/cerez-politikasi" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ display: 'inline-block', marginBottom: 8, color: '#333', fontWeight: '600', textDecoration: 'underline', fontSize: 13 }}
          >
            Daha Fazla Bilgi
          </a>

          <div style={{ marginBottom: 4 }}>
            <button
              type="button"
              className="cookie-btn cookie-btn--accept"
              style={{ fontWeight: 'bold', padding: '10px 24px', fontSize: 13 }} 
              onClick={handleAcceptAll}
            >
              Tümünü Kabul Et
            </button>
          </div>

          {/* Accordion List */}
          <div style={{ borderTop: '1px solid #eee' }}>
            {/* Zorunlu */}
            <div style={{ borderBottom: '1px solid #eee', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flex: 1 }} onClick={() => toggleAccordion('zorunlu')}>
                  <span style={{ fontSize: 22, marginRight: 10, width: 20, textAlign: 'center', color: '#666', fontWeight: 300, userSelect: 'none' }}>
                    {openAccordion === 'zorunlu' ? '−' : '+'}
                  </span>
                  <h4 style={{ fontSize: 15, margin: 0, fontWeight: 500, color: '#333', userSelect: 'none' }}>
                    Zorunlu Çerezler
                  </h4>
                </div>
                <div>
                  <span style={{ color: '#0F2B4B', fontSize: 13, fontWeight: '700' }}>Her Zaman Etkin</span>
                </div>
              </div>
              {openAccordion === 'zorunlu' && (
                <div style={{ padding: '8px 0 8px 30px', fontSize: 13, color: '#555', lineHeight: '1.5' }}>
                  Zorunlu çerezler, Platform&apos;u görüntülemeniz esnasında cihazınıza yerleştirilen ve sunulan online servislerin düzgün şekilde çalışabilmesi için gerekli olan çerezlerdir. Söz konusu çerezler kullanıcının talep etmiş olduğu bir bilgi toplumu hizmetinin yerine getirilmesi için zorunlu olarak kullanılmaktadır. Bu çerezlerin kullanımı esnasında gerçekleştirdiğimiz veri işleme faaliyetleri için Kanun m.5 kapsamında &quot;Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması&quot; veri işleme şartına dayanmaktayız.

                  <div
                    onClick={() => setShowZorunluTable((prev) => !prev)}
                    style={{
                      marginTop: 10,
                      color: '#0F2B4B',
                      fontWeight: 600,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      userSelect: 'none',
                    }}
                  >
                    Tanımlama Bilgisi Ayrıntıları
                  </div>

                  {showZorunluTable && (
                    <div style={{ marginTop: 10, overflowX: 'auto' }}>
                      <table
                        style={{
                          width: '100%',
                          borderCollapse: 'collapse',
                          fontSize: 12,
                          backgroundColor: '#fff',
                        }}
                      >
                        <thead>
                          <tr>
                            {['Çerez / Anahtar Adı', 'Açıklama', 'Amaç', 'Saklanma Süresi'].map(
                              (head) => (
                                <th
                                  key={head}
                                  style={{
                                    border: '1px solid #e0e0e0',
                                    padding: '8px 10px',
                                    textAlign: 'left',
                                    fontWeight: 700,
                                    color: '#333',
                                    backgroundColor: '#f5f5f5',
                                    verticalAlign: 'middle',
                                    width:
                                      head === 'Çerez / Anahtar Adı' || head === 'Açıklama'
                                        ? '22%'
                                        : undefined,
                                  }}
                                >
                                  {head}
                                </th>
                              )
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {zorunluCookies.map((cookie) => (
                            <tr key={cookie.name}>
                              <td
                                style={{
                                  border: '1px solid #e0e0e0',
                                  padding: '8px 10px',
                                  verticalAlign: 'top',
                                  fontWeight: 600,
                                  color: '#333',
                                  wordBreak: 'break-word',
                                }}
                              >
                                {cookie.name}
                              </td>
                              <td style={{ border: '1px solid #e0e0e0', padding: '8px 10px', verticalAlign: 'top' }}>
                                {cookie.description}
                              </td>
                              <td style={{ border: '1px solid #e0e0e0', padding: '8px 10px', verticalAlign: 'top' }}>
                                {cookie.purpose}
                              </td>
                              <td style={{ border: '1px solid #e0e0e0', padding: '8px 10px', verticalAlign: 'top' }}>
                                {cookie.duration}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* İşlevsellik */}
            <div style={{ borderBottom: '1px solid #eee', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flex: 1 }} onClick={() => toggleAccordion('islevsellik')}>
                  <span style={{ fontSize: 22, marginRight: 10, width: 20, textAlign: 'center', color: '#666', fontWeight: 300, userSelect: 'none' }}>
                    {openAccordion === 'islevsellik' ? '−' : '+'}
                  </span>
                  <h4 style={{ fontSize: 15, margin: 0, fontWeight: 500, color: '#333', userSelect: 'none' }}>
                    İşlevsellik İçin Gerekli Olan Çerezler
                  </h4>
                </div>
                <div className="cookie-custom-slider">
                  <input
                    type="checkbox"
                    id="cookie-func-switch"
                    value={funcCookiesSw}
                    onChange={(e) => setFuncCookiesSw(e.target.checked)}
                    checked={funcCookiesSw}
                  />
                  <label htmlFor="cookie-func-switch">Toggle</label>
                </div>
              </div>
              {openAccordion === 'islevsellik' && (
                <div style={{ padding: '8px 0 8px 30px', fontSize: 13, color: '#555', lineHeight: '1.5' }}>
                  İşlevsellik çerezleri, Platform üzerindeki belirli işlevlerin sağlanması ve bunlara dair kişiselleştirme ve tercihlerinizin hatırlanması için kullanılan çerezlerdir. Platform üzerinde dil tercihinizi hatırlamak ya da çerez kullanımına yönelik ayarlarınızı kaydetmek için işlevsellik çerezleri kullanılır. İlgili bilgi toplumu hizmetini açıkça talep etmediğiniz hallerde söz konusu olan çerezlerin kullanımı esnasında gerçekleştirdiğimiz veri işleme faaliyetleri için Kanun m.5 kapsamında, söz konusu olması halinde, açık rızanıza dayanmaktayız.
                </div>
              )}
            </div>

            {/* Hedefleme */}
            <div style={{ borderBottom: '1px solid #eee', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flex: 1 }} onClick={() => toggleAccordion('hedefleme')}>
                  <span style={{ fontSize: 22, marginRight: 10, width: 20, textAlign: 'center', color: '#666', fontWeight: 300, userSelect: 'none' }}>
                    {openAccordion === 'hedefleme' ? '−' : '+'}
                  </span>
                  <h4 style={{ fontSize: 15, margin: 0, fontWeight: 500, color: '#333', userSelect: 'none' }}>
                    Hedefleme ve Kişiselleştirilmiş Reklam Çerezleri
                  </h4>
                </div>
                <div className="cookie-custom-slider">
                  <input
                    type="checkbox"
                    id="cookie-target-switch"
                    value={targetCookiesSw}
                    onChange={(e) => setTargetCookiesSw(e.target.checked)}
                    checked={targetCookiesSw}
                  />
                  <label htmlFor="cookie-target-switch">Toggle</label>
                </div>
              </div>
              {openAccordion === 'hedefleme' && (
                <div style={{ padding: '8px 0 8px 30px', fontSize: 13, color: '#555', lineHeight: '1.5' }}>
                  Hedefleme ve kişiselleştirilmiş reklam çerezleri, sizlere Platform&apos;da veya Platform haricindeki mecralarda görüntüleme geçmişinize ve ziyaretçi profilinize uygun olarak kişiselleştirilmiş ürün ve hizmet tanıtımı yapmak için kullanılır. Bu çerezlerin kullanımı esnasında gerçekleştirdiğimiz veri işleme faaliyetleri için Kanun m.5 kapsamında veri işleme şartı olarak &quot;açık rızanıza&quot; dayanmaktayız.
                </div>
              )}
            </div>

            {/* Performans */}
            <div style={{ borderBottom: '1px solid #eee', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flex: 1 }} onClick={() => toggleAccordion('performans')}>
                  <span style={{ fontSize: 22, marginRight: 10, width: 20, textAlign: 'center', color: '#666', fontWeight: 300, userSelect: 'none' }}>
                    {openAccordion === 'performans' ? '−' : '+'}
                  </span>
                  <h4 style={{ fontSize: 15, margin: 0, fontWeight: 500, color: '#333', userSelect: 'none' }}>
                    Performans ve Analiz İçin Gerekli Olan Çerezler
                  </h4>
                </div>
                <div className="cookie-custom-slider">
                  <input
                    type="checkbox"
                    id="cookie-perf-switch"
                    value={perfCookiesSw}
                    onChange={(e) => setPerfCookiesSw(e.target.checked)}
                    checked={perfCookiesSw}
                  />
                  <label htmlFor="cookie-perf-switch">Toggle</label>
                </div>
              </div>
              {openAccordion === 'performans' && (
                <div style={{ padding: '8px 0 8px 30px', fontSize: 13, color: '#555', lineHeight: '1.5' }}>
                  Performans çerezleri, Platform ziyaret ve trafiğini takip ve analiz etmemizi ve bu analiz amacıyla istatistiki ölçüm yapmamızı sağlar. Bu çerezler sayesinde Platform üzerindeki alanlardan hangilerinin en sık ya da seyrek ziyaret edildiği gibi bilgileri edinebilir ve Platform&apos;un trafiğini optimize edebiliriz. İlgili bilgi toplumu hizmetini açıkça talep etmediğiniz hallerde söz konusu olan çerezlerin ve üçüncü taraf analitik çerezlerinin kullanımı esnasında gerçekleştirdiğimiz veri işleme faaliyetleri için Kanun m.5 kapsamında, söz konusu olması halinde, açık rızanıza dayanmaktayız.
                </div>
              )}
            </div>

          </div>

          {/* Footer actions */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 0,
              paddingTop: 12,
            }}
          >
            <button
              type="button"
              className="btn btn-blue py-2 px-4 rounded-3"
              style={{ fontSize: '14px', minWidth: '200px' }}
              onClick={handleSavePolicy}
            >
              Çerez Ayarlarını Kaydet
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CookieBanner;
